import React from 'react';
import { Container } from 'semantic-ui-react';
import Selectors from '@/layout/hooks/selectors';
import FairLayout from './FairLayout';

const RibbonLayout = () => {
  const { context } = Selectors.useLayoutContext();
  const elements = [];
  if (context === 'fair') {
    elements.push(<FairLayout key="fair_layout" />);
  }

  if (elements.length === 0) {
    return (<div />);
  }

  return (
    <Container floated="right" className="view-switcher aridhia-ribbon-layout">
      {elements}
    </Container>
  );
};

export default RibbonLayout;
